/**
 * Updates the cart data based on the response received from the server.
 * Processes items in the cart, differentiating between base items and addons,
 * and calculates totals for the cart.
 *
 * @param {Object} resp - The response object containing cart data.
 * @param {number} resp.totalShipping - The total shipping cost.
 * @param {number} resp.total - The total cost of the cart.
 * @param {number} resp.donationAmount - The total donation amount included in the cart.
 *
 * @returns {Object} An updated cart data object containing:
 */
const updateCartDetails = (resp) => {
  const cartData = {};

  cartData.paymentInfo = {
    baseItemTotal: resp.orderSubTotal || 0,
    totalShipping: resp.orderShippingTotal || 0,
    total: resp.orderGrandTotal || 0,
    couponCode: resp.couponCode,
    donationAmount: resp.donationAmount || 0,
    discountOnMRP: resp?.discountOnMRP || 0,
    orderSavedAmount: Math.abs(resp.discountOnMRP) + Math.abs(resp?.totalDiscountAmount || 0),
    orderTotalMRP: resp?.pricingSummary?.orderTotalMRP || 0,
    discount: resp?.totalDiscountAmount || 0,
    additionalPromoAdjustment: resp?.additionalPromoAdjustment,
    labelText: resp.labelText,
    termAndConditions: resp.termAndConditions,
    donationStatus: resp.donationStatus,
    carryBagAmount: resp?.carryBagAmount,
    isBinPromoCodeApplied: resp?.isBinPromoCodeApplied,
    partnerId: resp?.partnerRewards?.partnerId,
    partnerLogoUrl: resp?.partnerRewards?.partnerLogoUrl,
    partnerName: resp?.partnerRewards?.partnerName,
    partnerPoints: resp?.partnerRewards?.points,
    totalServiceCharge: resp?.totalServiceCharge,
  };
  return { ...cartData };
};

export default updateCartDetails;
